import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Register() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      setUser(data);
      toast.success("Conta criada com sucesso!");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-4 py-16">
      <h1 className="font-heading font-black text-3xl text-brand-text">Criar conta</h1>
      <p className="mt-2 text-brand-textMuted">Junte-se à comunidade que come bem sem riscos.</p>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <Input data-testid="name-input" required placeholder="Seu nome" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-brand-bg border-brand-border rounded-2xl h-12" />
        <Input data-testid="email-input" required type="email" placeholder="E-mail" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-brand-bg border-brand-border rounded-2xl h-12" />
        <Input data-testid="password-input" required type="password" placeholder="Senha (mínimo 6 caracteres)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="bg-brand-bg border-brand-border rounded-2xl h-12" />
        <Button data-testid="register-submit-btn" disabled={loading} className="w-full bg-brand-primary hover:bg-brand-primaryHover text-white rounded-full font-bold py-6">
          {loading ? "Criando..." : "Criar conta"}
        </Button>
      </form>

      <p className="mt-6 text-sm text-brand-textMuted text-center">
        Já tem conta? <Link to="/login" className="text-brand-primary font-bold hover:underline">Entrar</Link>
      </p>
    </div>
  );
}
